// @ts-nocheck
import React from 'react';

/**
 * StepperProgress — horizontal numbered steps with connector lines.
 *
 *   <StepperProgress
 *     current={1}
 *     steps={[{ label: 'Install' }, { label: 'Verify' }, { label: 'Launch' }]}
 *   />
 */
const StepperProgress = ({ steps = [], current = 0, className = '' }) => (
  <div className={['flex items-center gap-0', className].join(' ')}>
    {steps.map((s, i) => {
      const done = i < current;
      const on = i === current;
      return (
        <React.Fragment key={s.label || i}>
          <div className="flex items-center gap-2.5 flex-1 min-w-0">
            <div
              className="mov-mono grid place-items-center shrink-0"
              style={{
                width: 26, height: 26, borderRadius: '50%',
                border: `1px solid ${done || on ? 'var(--mov-accent)' : 'var(--mov-line-strong)'}`,
                background: done ? 'var(--mov-accent)' : 'var(--mov-paper)',
                color: done ? '#fff' : on ? 'var(--mov-accent-ink)' : 'var(--mov-ink-soft)',
                fontSize: 11,
                boxShadow: on ? '0 0 0 4px var(--mov-accent-soft)' : 'none',
              }}
            >
              {done ? '✓' : i + 1}
            </div>
            <span
              className="text-[12.5px] font-medium truncate"
              style={{ color: done || on ? 'var(--mov-ink)' : 'var(--mov-ink-mute)' }}
            >
              {s.label}
            </span>
          </div>
          {i < steps.length - 1 && (
            <div
              style={{ flex: 1, height: 1, background: done ? 'var(--mov-accent)' : 'var(--mov-line)', margin: '0 8px' }}
            />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default StepperProgress;
